import { clearAuthUser, setAuthUser } from '@/src/redux/slices/authSlice'
import { Dispatch } from 'redux'

export interface AuthUserData {
    signedIn: boolean
    email: string
    fullName: string
    userId?: string | number
    picture?: string
}

/**
 * Process auth response and validate user roles
 * Returns null if validation fails (caller should handle redirect)
 */
export const processAuthResponse = (
    response: any, 
    dispatch: Dispatch, 
    defaultEmail?: string
): AuthUserData | null => {
    
    
    // Handle regular auth response
    if (response?.status === 'Success' && response?.statusCode === 200) {
        const email = response.email || defaultEmail || ''

        const authData: AuthUserData = {
            signedIn: true,
            email,
            fullName: response.screenName || '',
            userId: response.userid
        }

        // Set the auth data from the response for immediate UI update
        dispatch(setAuthUser(authData))
        console.log('[Auth] User authenticated successfully:', email)
        return authData
    }

    console.warn('[Auth] Invalid response structure - no user data found')
    return null
}

/**
 * Clear authentication state
 */
export const clearAuthState = (dispatch: Dispatch) => {
    dispatch(
        setAuthUser({
            signedIn: false,
            email: undefined,
            firstName: undefined,
            lastName: undefined,
            fullName: undefined,
            userId: undefined,
            picture: undefined
        })
    )
    console.log('[Auth] Auth state cleared')
}

export interface SignUpPayload {
    email: string
    password: string
    firstName: string
    lastName: string
    title: string
    marketingSubscription: boolean
}

/**
 * Construct signup payload for API
 */
export const constructSignUpPayload = (data: SignUpPayload): any => {
    return {
        usertitle: data.title,
        userfname: data.firstName,
        userlname: data.lastName,
        username: data.email,
        password: data.password,
        groupType: null,
        rewards: false,
        wallet: true,
        mkrtngSubscription: data.marketingSubscription ? 1 : 0,
        dm_type: typeof window !== 'undefined' ? window.location.host : ''
    }
}